export default __webpack_public_path__ + "using-shake-in-beta-testing.jpg";